import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';

/**
 * <MobileSaleTotalBar>  — mobile-only fixed footer (md:hidden).
 *
 * As of Jul 2026 this bar is deliberately MINIMAL: it only exposes the
 * primary save action (Save Draft / Save Quote / Save Invoice). The
 * live totals readout that used to live here has been *moved into the
 * fullscreen barcode scanner overlay* so we don't duplicate the same
 * numbers in two places — the operator sees them exactly where they
 * matter (while scanning) and the invoice page stays clean.
 *
 * Props:
 *   primaryLabel  – CTA label (e.g. "Save Draft")
 *   onPrimary     – click handler
 *   loading       – shows spinner, disables the CTA
 *   disabled      – disables the CTA (e.g. no line items)
 *   accentColor   – Tailwind bg class for the CTA
 */
export const MobileSaleTotalBar = ({
    primaryLabel = 'Save',
    onPrimary,
    loading = false,
    disabled = false,
    accentColor = 'bg-[#1A1A1A]',
}) => {
    return (
        <div
            data-testid="mobile-sale-total-bar"
            className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-[#E5E5E5]
                       bg-white/95 backdrop-blur-md shadow-[0_-4px_16px_-4px_rgba(0,0,0,0.08)]
                       pb-[env(safe-area-inset-bottom)]"
        >
            <div className="px-4 py-2.5 flex items-center justify-end">
                <Button
                    type="button"
                    onClick={onPrimary}
                    disabled={disabled || loading}
                    data-testid="mobile-bar-primary-btn"
                    className={`${accentColor} hover:opacity-90 text-white rounded-full px-6 h-11 font-medium min-w-[9rem]`}
                >
                    {loading ? <Loader2 className="animate-spin" size={16} /> : primaryLabel}
                </Button>
            </div>
        </div>
    );
};

export default MobileSaleTotalBar;
